import type { PayloadAction } from "@reduxjs/toolkit";
import type { SurveyContact } from "@survey-types/survey.contacts.types";
import type { currentSurveySliceState } from "@survey-types/survey.core.types";
import {
  addItemWithOrder,
  findAndUpdateById,
  removeByIdAndReorder,
  reorderArrayItems,
} from "@survey/utils/reducerFactory";

// =====================================
// SURVEY CONTACTS MANAGEMENT
// =====================================

export const contactReducers = {
  addContact: (
    state: currentSurveySliceState,
    action: PayloadAction<SurveyContact>,
  ) => {
    if (state.currentSurvey?.contacts) {
      state.currentSurvey.contacts = addItemWithOrder(
        state.currentSurvey.contacts,
        action.payload,
      );
    }
  },

  updateContact: (
    state: currentSurveySliceState,
    action: PayloadAction<{
      contactId: string;
      updates: Partial<SurveyContact>;
    }>,
  ) => {
    if (state.currentSurvey?.contacts) {
      const { contactId, updates } = action.payload;
      state.currentSurvey.contacts = findAndUpdateById(
        state.currentSurvey.contacts,
        contactId,
        "contactId",
        updates,
      );
    }
  },

  removeContact: (
    state: currentSurveySliceState,
    action: PayloadAction<string>,
  ) => {
    if (state.currentSurvey?.contacts) {
      state.currentSurvey.contacts = removeByIdAndReorder(
        state.currentSurvey.contacts,
        action.payload,
        "contactId",
      );
    }
  },

  reorderContacts: (
    state: currentSurveySliceState,
    action: PayloadAction<{
      sourceIndex: number;
      destinationIndex: number;
    }>,
  ) => {
    if (state.currentSurvey?.contacts) {
      const { sourceIndex, destinationIndex } = action.payload;
      state.currentSurvey.contacts = reorderArrayItems(
        state.currentSurvey.contacts,
        sourceIndex,
        destinationIndex,
      );
    }
  },

  setContactEditingId: (
    state: currentSurveySliceState,
    action: PayloadAction<string | null>,
  ) => {
    state.editingContactId = action.payload;
  },
};
